<template>
  <div class="ui-recent" :class="version == 'horiz'?'h-17':'h-19'">
    <div id="ui-filter" v-if="surplusStatus"></div>
    <!-- <NoneData tips='加载中...' :version='version' class="flex" v-else></NoneData> -->
  </div>
</template>

<script>
import fitChartSize from "@/common/js/echartFontSize.js";
import NoneData from '@/components/NoneData.vue'
export default {
  props: {
    filterListPro: {
      type: Array,
      default: []
    }, 
    surplusStatus:{
        type:Boolean,
        default:false
    }, 
    version: {
      type: String
    }
  },
  data() {
    return {
      dataX: [],
      dataZ:[],
      dataY: [],
      timer:null
    };
  },
  components:{
    NoneData
  },
  watch: {
    filterListPro(val) {
      this.dataX =[];
      this.dataZ =[];
      this.dataY =[];
      val.map(item => {
        let surplus = item.filterPercent;
        this.dataX.push(surplus); 
        this.dataZ.push(100); 
        this.dataY.push(item.filterName);
      }); 
      setTimeout(()=>{
          this.initGrandEcharts();
      },500) 
    }
  }, 
  methods: {
    // 滤芯使用情况
    initGrandEcharts() {
      let that = this;
      let datasX = JSON.parse(JSON.stringify(that.dataX));
      let datasZ = that.dataZ; 
      let datasY = JSON.parse(JSON.stringify(that.dataY)); 
      let myChart = echarts.init(document.getElementById("ui-filter"), null, {
        renderer: "svg"
      });
      let color = new echarts.graphic.LinearGradient(
        0,
        1,
        0,
        0,
        [
          {
            offset: 0,
            color: "rgba(135,206,250,0)"
          },
          {
            offset: 1,
            color: "#87CEFA"
          }
        ],
        false
      );
      if (datasY.length > 0 || datasX.length > 0) {
        let option = { 
          grid: {
            left: "0",
            right: "0",
            bottom: window.innerWidth<800?"-10%":'0',
            top: "10%",
            containLabel: true
          },
          color,
          xAxis: {
            type: "category", 
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: { show: false },
            show: false,
            axisTick: {
                show: false
            }, 
            splitNumber : 5,
            boundaryGap : [ 0.2, 0.2 ],
          },
          yAxis: {
            type: "value",  
            splitLine: {
                show: false,
            },
            axisLabel: {
              // color: "#D5F2FF",
              show:false,
              color: "#fff",
              fontSize:fitChartSize(14)
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }, 
          },
          series: [
            {
              type: "bar",
              barWidth:fitChartSize(20),
              label: {
                show: false,
                position: "right", 
                color: "#fff",
                formatter: "{c}%",
                fontSize:
                  this.version == "horiz" ? fitChartSize(12) : fitChartSize(16)
              },
              itemStyle: {
                borderRadius: [fitChartSize(10), fitChartSize(10), fitChartSize(10), fitChartSize(10)],
                borderWidth: fitChartSize(150), 
              },
              data: datasX,
              z: 2
            }, 
            {
              name: '外框',
              type: 'bar', 
              barGap: '-100%',
              barWidth:fitChartSize(25),
              data: datasZ,
              itemStyle: {
                  normal: {
                    color: 'transparent',  
                    borderWidth: fitChartSize(30), 
                    borderRadius: fitChartSize(20), 
                  }
              },
              z: 0
            }
          ]
        };
        myChart.clear();
        myChart.setOption(option, true);
        // 点击图表
        // myChart.on('click', function (params) {  
        //   that.$router.push(`/filterUse?filterCode=${that.filterListPro[params.dataIndex].filterCode}&hardwareCode=${that.hardwareCode}&storeDataCode=${that.storeDataCode}}`)
        // });
        window.addEventListener("resize", function() {
          myChart.resize();
        });
        if(this.dataY && this.dataY.length>6){
          let index = 0; //top多少就从多少开始
          this.timer = setInterval(function() {
            var axisData = that.dataY[index];
            var data0 = option.series[0].data;
            data0.shift();
            data0.push(that.dataX[index]);
            option.yAxis.data.shift();
            option.yAxis.data.push(axisData);
            myChart.setOption(option, true);
            index += 1;
            if (index >= that.dataY.length) {
              index = 0;
            }
            window.addEventListener("resize", function() {
              myChart.resize();
            });
          }, 2000);
        } 
      } else {
        // let optionNoData = {
        //   title: {
        //     text: "暂无数据",
        //     x: "center",
        //     y: "center",
        //     textStyle: {
        //       color: "#ccc",
        //       fontWeight: "normal",
        //       fill: "#9d9d9d",
        //       fontWeight: "bold",
        //       text: "暂无数据",
        //       fontFamily: "Microsoft YaHei",
        //       fontSize:fitChartSize(18)
        //     }
        //   }
        // }; 
        // myChart.clear();
        // myChart.setOption(optionNoData, true);
        // window.addEventListener("resize", function() {
        //   myChart.resize();
        // });
      }
    }
  },
  destroyed(){  
    if(this.timer){
      clearInterval(this.timer);
      this.timer = null;
    } 
  }
};
</script>

<style lang="scss" scoped>
.h-19 { 
}
.h-17 { 
  width: 100%;
  height: 100%;  
} 
#ui-filter {
  width: 100%;
  height: 100%; 
}
</style>



// WEBPACK FOOTER //
// src/components/HorizlBar.vue